<template>
  <v-card-text class="pa-2">
    <i class="text-cc-subtle">
      This is the locally-saved user data. These items should generally not have to be reset, but
      may be useful in debugging or clearing a persistent loading issue.
      <br />
      Resetting User Data will not reset achievement unlocks (this can be done in the Achievement
      Browser).
    </i>

    <v-table class="text-left mt-2"
      density="compact">
      <thead>
        <tr>
          <th>Item</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="key in userDataKeys" :key="key">
          <td v-text="key.replace('_', '')" />
          <td v-if="key === '_options'">
            <v-row dense>
              <v-col cols="4"
                v-for="viewKey in Object.keys(user[key].views)"
              :key="viewKey">
                {{ viewKey }}:
                <b class="text-accent">{{ user[key].views[viewKey] }}</b>
              </v-col>
            </v-row>
          </td>
          <td v-else-if="Array.isArray(user[key])"
            v-text="`${user[key].length} items`" />
          <td v-else
            v-text="user[key]" />
        </tr>
      </tbody>
    </v-table>

    <div class="text-right">
      <cc-button size="small"
        variant="tonal"
        color="error"
        @click="resetUserData()">
        Reset User Data
      </cc-button>
    </div>
  </v-card-text>
</template>

<script lang="ts">
import { UserStore } from '@/stores';
import { useMobile } from '@/mixins/useMobile';


export default {
  mixins: [useMobile],
  name: 'deleted-items',
  data: () => ({
    resetDialog: false,
  }),
  computed: {
    user() {
      return UserStore().User;
    },
    userDataKeys() {
      const skipKeys = ['LcpSubscriptionData', '_patreonData', '_itchData'];
      if (this.mobile) {
        skipKeys.push('_options');
      }
      const data = [...Object.keys(UserStore().User)];
      return data.filter((key) => !skipKeys.includes(key));
    },
  },
  methods: {
    resetUserData() {
      this.user.Reset();
      this.$vuetify.theme.global.name = this.user.Theme;
      this.resetDialog = false;
    },
  },
};
</script>
